/*
 * @Date: 2023-11-01 13:37:21
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-10-10 17:42:09
 * @FilePath: /nicee-web-tw/src/components/GameRoom/gameRoomEvent.js
 * @Description: 语音房事件名
 */
const GameRoomEvent = {
  onInitGame: 'onInitGame', // 初始化游戏
  sendMessage: 'sendMessage'
};
export default GameRoomEvent;
